import React, { useState } from 'react';
import { LuSearch } from '../../utils/icons';

interface SearchBarProps {
  placeholder?: string;
  context?: string;
  onSearch?: (query: string) => void;
  className?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = 'Type here...',
  context,
  onSearch,
  className = '',
}) => {
  const [query, setQuery] = useState('');
  const SearchIcon = LuSearch as React.ComponentType<{ size?: number; className?: string }>;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch?.(query);
  };

  return (
    <form onSubmit={handleSubmit} className={`relative flex flex-wrap items-stretch w-full transition-all rounded-lg ease-soft ${className}`}>
      <span className="text-sm ease-soft leading-5.6 absolute z-50 -ml-px flex h-full items-center whitespace-nowrap rounded-lg rounded-tr-none rounded-br-none border border-r-0 border-transparent bg-transparent py-2 px-2.5 text-center font-normal text-slate-500 dark:text-slate-400 transition-all">
        <SearchIcon size={16} />
      </span>
      <input
        type="text"
        className="pl-8.75 text-sm ease-soft w-1/100 leading-5.6 relative -ml-px block min-w-0 flex-auto rounded-lg border border-solid border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800 bg-clip-padding py-2 pr-3 text-gray-700 dark:text-slate-200 transition-all placeholder:text-gray-500 dark:placeholder:text-slate-400 focus:border-primary-300 focus:outline-none"
        placeholder={placeholder}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
    </form>
  );
};

export default SearchBar;
